import React, { useState } from "react";
import FormattedMessage from "components/FormattedMessage";
import Spinner, { styles } from "components/Spinner";
import { Box, Flex, Text, Image, Button } from "ui-components";
import { buttonThemes } from "ui-components/theme";
import VisaLogo from "assets/images/visa.png";
import get from "lodash/get";
import OTPModal from "components/OTPModal";
import { formatCurrency, gotoUrl } from "utils/helpers";
import { ORDER_ACTION_TYPES, paths } from "utils/constants";

const OutstandingPaymentCard = ({
  themeVariant,
  padding,
  outstandingBillsDomain,
  payOutstandingBills,
  isOtpVerified,
  validateSignatureDomain,
  formValues,
  pay_text,
  update_card_text,
  outstandingBillToken,
  isFetchingPayOutstandingBills,
  isPaying,
  appSettings,
  isWalletPayment
}) => {
  const payment_info = get(outstandingBillsDomain, "payment_info");
  const walletBalance = get(outstandingBillsDomain, "payment_info.balance", 0);

  const total = get(outstandingBillsDomain, "total");
  const serviceInstanceNumber = get(
    outstandingBillsDomain,
    "serviceInstanceNumber"
  );
  const outstandingPaymentToken = get(validateSignatureDomain, "session_token");
  const redirectUrl = window.location.href;

  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);

  const disablePayButton = isPaying || isFetchingPayOutstandingBills;

  const onOTPSubmitSuccess = sessionToken => {
    gotoUrl(
      `${paths.PAYMENT_CARD_UPDATE}?sin=${serviceInstanceNumber}&return_path=${redirectUrl}&cc_update=true`
    );
  };

  return (
    <>
      {isWalletPayment ? (
        <>
          <Box variant={themeVariant} padding={padding}>
            <Flex width={1} flexDirection={"column"}>
              <Flex flexDirection={"row"} justifyContent={"space-between"}>
                <Flex flexDirection={"column"}>
                  <Image
                    src="https://logowik.com/content/uploads/images/airwallex8853.logowik.com.webp"
                    sx={{ height: "6rem", width: "auto" }}
                    ml={6}
                  />
                </Flex>
                <Flex flexDirection={"row"} alignItems={"center"}>
                  <Text>Balance:</Text>

                  <Text fontWeight="bolder" py="4px" px="7px">
                    {`$${formatCurrency(payment_info.balance, "SGD")}`}
                  </Text>
                </Flex>
              </Flex>
              {walletBalance < total.amount ? (
                <center>
                  <Box py="4px">
                    <FormattedMessage
                      id={"wallet_insufficient_balance_message"}
                    />
                  </Box>
                  <Text fontWeight="bolder" pt="10px" px="7px">
                    {`Total outstanding: $${total.amount}`}
                  </Text>
                </center>
              ) : (
                total &&
                total.amount > 0 && (
                  <Button
                    onClick={() => {
                      let params = { token: outstandingBillToken };
                      payOutstandingBills(params);
                    }}
                    disabled={disablePayButton}
                    sx={{ height: "3rem", width: "8rem", margin: "auto" }}
                  >
                    {!disablePayButton ? (
                      <FormattedMessage
                        html
                        id={"Pay " + total.prefix + total.amount}
                      />
                    ) : (
                      <Spinner size={19} sx={styles.button} />
                    )}
                  </Button>
                )
              )}
            </Flex>
          </Box>

          <OTPModal
            outstandingPaymentToken={outstandingPaymentToken}
            orderActionName={ORDER_ACTION_TYPES.OUTSTANDING_BILLS}
            showModal={showModal}
            closeModal={closeModal}
            buttonTheme={buttonThemes.blue}
            onSuccess={onOTPSubmitSuccess}
            appSettings={appSettings}
          />
        </>
      ) : (
        <>
          <Box variant={themeVariant} padding={padding}>
            <Flex width={1} flexDirection={"column"}>
              <Flex flexDirection={"row"} justifyContent={"space-between"}>
                <Flex flexDirection={"column"}>
                  <Image
                    src={VisaLogo}
                    sx={{ height: "6rem", width: "6rem" }}
                    ml={6}
                  />
                </Flex>
                <Flex flexDirection={"column"} justifyContent={"center"}>
                  {payment_info && (
                    <Text>{"**** **** **** " + payment_info.card_no}</Text>
                  )}

                  <Button
                    onClick={() => {
                      if (!isOtpVerified) {
                        setShowModal(true);
                      } else {
                        gotoUrl(
                          `${paths.PAYMENT_CARD_UPDATE}?sin=${serviceInstanceNumber}&return_path=${redirectUrl}&cc_update=true`
                        );
                      }
                    }}
                    sx={{ color: "#0000FF" }}
                    style={{ background: "none", border: "none" }}
                  >
                    <FormattedMessage id={update_card_text} />
                  </Button>
                </Flex>
              </Flex>
              {total && total.amount > 0 && (
                <Button
                  onClick={() => {
                    let params = { token: outstandingBillToken };
                    payOutstandingBills(params);
                  }}
                  disabled={disablePayButton}
                  sx={{ height: "3rem", width: "8rem", margin: "auto" }}
                >
                  {!disablePayButton ? (
                    <FormattedMessage
                      html
                      id={"Pay " + total.prefix + total.amount}
                    />
                  ) : (
                    <Spinner size={19} sx={styles.button} />
                  )}
                </Button>
              )}
            </Flex>
          </Box>

          <OTPModal
            outstandingPaymentToken={outstandingPaymentToken}
            orderActionName={ORDER_ACTION_TYPES.OUTSTANDING_BILLS}
            showModal={showModal}
            closeModal={closeModal}
            buttonTheme={buttonThemes.blue}
            onSuccess={onOTPSubmitSuccess}
            appSettings={appSettings}
          />
        </>
      )}
    </>
  );
};

OutstandingPaymentCard.defaultProps = {
  pay_text: "pay_text",
  update_card_text: "update_card_text",
  data: {},
  themeVariant: "main",
  invoices: [],
  outstandingBillsDomain: {}
};

export default OutstandingPaymentCard;
